(function () {
	Vue.component('nominow-import-export-modal', {
		props: {
			data: {
				type: Object,
				required: true,
				default: () => ({
					import: () => { }
				})
			}
		},
		data: function () {
			return {
				error: null,
				item: this.data
			};
		},
		template: `
        <div>
            <h2>{{item.title}}</h2>
            <p>{{item.subTitle}}</p><br/>
            <nominow-input-textarea v-model="item.jsonString" label="Json" :rows="20"></nominow-input-textarea>
            <p><br><strong>{{item.note}}</strong></p><br/>
            <button class="button is-primary" v-on:click.prevent="importItem" v-if="data.import">Add</button>
        </div>
        `,
		methods: {
			importItem: function () {
				this.data.import(this.item);
			}
		}
	});
})();
